import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-aside',
    templateUrl: './app-aside.component.html',
    styles: ['./app-aside.componenet.scss']
})
export class AppAsideComponent implements OnInit {
    constructor() {}

    ngOnInit() {
        
//        console.log(this.user);
    }
}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-aside/app-aside.component.ts